import React from 'react';
import { Button, Slider } from 'antd';

const lightTemperatureMarks = {
    1600: {
        label: <span className='manrope f-10 black'>Candle</span>
    },
    3600: {
        label: <span className='manrope f-10 black'>Warm</span>
    },
    5000: {
        label: <span className='manrope f-10 black'>Day</span>
    },
    7000: {
        label: <span className='manrope f-10 black'>Cloudy</span>
    }
  };


export default function SiloLightingTemperature(props) {
  return (
    <div style={{marginTop:"5px"}}>
        <span className='manrope f-14 black silo-heading-main'>
            Lighting Temperature
        </span>
        <span style={{marginLeft:"2px"}} className='manrope f-12'>
            Drag and release the slider to change the color of the lighting
        </span>
        <div style={{display:'flex', flexDirection:"row", alignItems:'baseline'}}>                
            <Slider marks={lightTemperatureMarks} tooltip={{ formatter: null }} value={props.lightTemperature} onChange={(val) => {props.setLightTemperature(val)}} onAfterChange={(value) => {props.onChangeTemperature(value)}} step={200} className='color-temp-slider' min={1000} max={10000} style={{background: 'linear-gradient(270deg, #C4D2F9 3%, #FAE5CE 50%, #EB4A27 100%)',marginTop:"2vh", borderRadius:"4px", height:"5px", width:"85%"}}/>
            <Button style={{marginLeft:"5px"}} onClick={() => {
                props.onChangeTemperature(5000)
            }} className='modal-okay-blue square medium font-12'>
                Reset
            </Button>
        </div>

    </div>   
  ) 
}
